export function normalizeRedeemCodeInput(raw: string): string | null {
  const digits = raw.trim().replace(/\D+/g, '');
  if (digits.length !== 12) return null;
  return `${digits.slice(0, 4)} ${digits.slice(4, 8)} ${digits.slice(8, 12)}`;
}

export function formatRedeemCodeDisplay(code: string): string {
  const normalized = normalizeRedeemCodeInput(code);
  return normalized ?? code;
}
